import base from './base';
import components from './components';

export default { base, ...components };
